export default __webpack_public_path__ + "static/media/detail_active.09dd47a6.svg";